export default __webpack_public_path__ + "static/equipment-2-1376af41837d56652d75e47f050d4528.jpg";